module.exports = __webpack_public_path__ + "static/media/searchcontrols.63668b6b.jpg";